goog.provide('el8.util.amplitude.letterHelpers');

goog.require('el8.model.identify');
goog.require('el8.util.amplitude.helpers');
goog.require('el8.util.consts');


/**
 * Log that a create letter event occurred.
 *
 * @param {string} source : where in the app the create letter was triggered
 * @param {string} letterType : is it a referral, provider letter, or patient letter
 */
el8.util.amplitude.logStartLetter = function (source, letterType) {
    var ampData = {
        source: source,
        'letter type': letterType
    };
    var eventType = letterType===el8.util.consts.REFERRAL_LETTER ? "start referral" : "start letter";
    el8.util.amplitude.logEvent(eventType, ampData, false);
};


/**
 * Log that a user has opened the contact dialog to edit a contact from the letter/referral.
 *
 * @param {string} source : where in the app the dialog was opened from
 */
el8.util.amplitude.logOpenContactDialog = function (source) {
    var ampData = {source: source,};
    el8.util.amplitude.logEvent("open contact dialog", ampData, false);
};

/**
 * Log that a user is editing a letter/referral recipient.
 *
 * @param {string} action : what action triggered the event
 */
el8.util.amplitude.logEditLetterRecipient = function (action) {
    var ampData = {actions: action};
    el8.util.amplitude.logEvent("edit letter recipient", ampData, false);
};

/**
 * Log that a letter was completed. It will require information like what was
 * the text of the button/link that was clicked.
 *
 * @param {string} action : what the text was on the clicked button (e.g. Sign & Send)
 * @param {letter} letter : front end model instance for Letter/ReferralOrder. See el8.ptdata.model.letter
 */
el8.util.amplitude.logCompleteLetter = function (action, letter) {
    // don't want to log if letter is not the letter instance
    if (!letter) { return; }

    var ampData = {
        action: action,
        'transmission method': letter.getDeliveryMethod(),
        'number of attachments': letter.getAttachments().length,
        'fax copies': letter.isFaxAttachments(),
        'recipient account type': letter.getDeliveryMethod(),
        'recipient type': letter.getRecipientType(),
        'grant access in letter': letter.isWithPlrInvite()
    };
    var eventType = letter.getLetterType()===el8.util.consts.REFERRAL_LETTER ? "complete referral" : "complete letter";
    el8.util.amplitude.logEvent(eventType, ampData, false);

    if (el8Globals.FEATURES.PLR4Everyone && letter.isWithPlrInvite()) {
        el8.util.amplitude.logEvent('grant access to share via collaborative record from letter');
    }
};

/**
 * Log that we added a recipient for a letter.
 *
 * @param {letter} letter : front end model instance for Letter/ReferralOrder. See el8.ptdata.model.letter
 */
el8.util.amplitude.logAddLetterRecipient = function (letter) {
    // don't want to log if letter is not the letter instance
    if (!letter) { return; }

    var ampData = {
        'recipient account type': letter.getDeliveryMethod(),
        'recipient type': letter.getRecipientType()
    };

    el8.util.amplitude.logEvent('add recipient', ampData, false);
};

/**
 * Maps technical communication type values to user-friendly event property values
 * @param {string} technicalType - The technical communication type (e.g., 'referral_letter')
 * @return {string} User-friendly communication type for amplitude events
 */
function getCommunicationType(technicalType) {
    var mapping = {
        'referral_letter': 'referral',
        'patient_letter': 'patient letter', 
        'provider_letter': 'provider letter'
    };
    return mapping[technicalType] || technicalType;
}

/**
 * Amplitude log when user applies a letter template
 * @param {string} communicationType - Technical communication type (e.g., 'patient_letter')
 */
el8.util.amplitude.logLetterTemplateAdded = function(communicationType) {
    el8.util.amplitude.logEvent("Letter Template Added", {
        "communication type": getCommunicationType(communicationType)
    });
};

/**
 * Amplitude log when user replies to a comment on a patient or provider letter
 * @param {object} spec - Specification object containing:
 *   - {string} message - The comment text that was submitted
 *   - {object} document - The letter or letter receipt document object
 *   - {string=} source - Optional source location override. If not provided, determined from el8Globals.APP
 */
el8.util.amplitude.logLetterCommentReply = function(spec) {
    if (!spec || !spec.message || !spec.document) { return; }
    
    var document = spec.document;
    var message = spec.message;
    
    // Determine source: use override if provided, otherwise determine from el8Globals.APP
    var source = spec.source;
    if (!source) {
        var sourceMap = {
            'chart': 'patient chart page',
            'home': 'practice home',
            'passport': 'patient passport page',
            'access': 'provider passport page'
        };
        source = sourceMap[el8Globals.APP] || 'unknown';
    }
    
    // Determine letter type using adaptive detection for different model types
    var letterType = el8.model.isPatientLetter(document) ? 'patient letter' : 'provider letter';
    
    var ampData = {
        'comment length': message.length,
        'letter type': letterType,
        'source': source
    };
    
    el8.util.amplitude.logEvent('Letter Comment Reply Sent', ampData);
};